export default __webpack_public_path__ + "static/media/04.66442b9e.jpg";